import { ApiDataAccess } from "../common/ApiDataAccess";
import { Cache } from "../common/Cache";

export class GenericDataAccess {
    constructor() {
        this.apiDataAccess = new ApiDataAccess('/data');
        this.cache = new Cache('generic-data-access', 60);
    }

    getMetaData(entity, onSuccess) {
        var self = this;
        var cacheKey = 'getMetaData.' + entity;
        var data = this.cache.get(cacheKey);
        if (data) {
            onSuccess(data);
        }
        else {
            var url = '/' + encodeURI(entity);
            self.apiDataAccess.put(
                url,
                null,
                function (data) {
                    self.cache.add(cacheKey, data);
                    onSuccess(data);
                },
                function (error) {
                    console.log(error);
                    //TODO: Migrate alerrt
                    //Alerts.showError('Could not retrieve meta data!');
                });
        }
    }

    saveItem(entity, data, onSuccess) {
        var url = '/' + encodeURI(entity);
        this.apiDataAccess.post(
            url,
            data,
            onSuccess,
            function (e) {
                if (e.messages) {
                    var txt = "The item was not saved because of the following reason(s):";
                    for (let m of e.messages) {
                        txt += "<br><b>" + m + "</b>";
                    }
                    //TODO: Migrate alerrt
                    //Alerts.showError(txt);
                }
                else {
                    //TODO: Migrate alerrt
                    //Alerts.showError('An error occurred while saving the data. Please try again.');
                }
            });
    }

    getItem(entity, id, onSuccess) {
        var url = '/' + encodeURI(entity) + '/' + encodeURI(id);
        this.apiDataAccess.get(
            url,
            onSuccess,
            function () {
                    //TODO: Migrate alerrt
                
                //Alerts.showError('Could not get item!');
            });
    }

    getFormattedItem(entity, id, onSuccess) {
        var url = '/' + encodeURI(entity) + '/' + encodeURI(id) + '?format=true';
        this.apiDataAccess.get(
            url,
            onSuccess,
            function () {
                    //TODO: Migrate alerrt

                //Alerts.showError('Could not retrieve formatted item!');
            });
    }

    deleteItem(entity, id, onSuccess) {
        var url = '/' + encodeURI(entity) + '/' + encodeURI(id);
        this.apiDataAccess.delete(
            url,
            onSuccess,
            function () {
                    //TODO: Migrate alerrt
                
                //Alerts.showError('Could not delete item!');
            }
        );
    }

    getList(entity, pageSize, pageIndex, filter, onSuccess) {
        var url = '/' + encodeURI(entity) + '/pageable?pagesize=' + encodeURI(pageSize) + '&pageIndex=' + encodeURI(pageIndex);
        if (filter) {
            url += '&filter=' + encodeURI(filter);
        }

        this.apiDataAccess.get(
            url,
            onSuccess,
            function () {
                    //TODO: Migrate alerrt
                
                //Alerts.showError('Could not retrieve list!');
            });
    }

    getDataSourceData(datasourceName, onSuccess) {
        var url = '/datasources/' + encodeURI(datasourceName);
        this.apiDataAccess.get(
            url,
            function (data) {
                onSuccess(data);
            },
            function () {
                    //TODO: Migrate alerrt

                //Alerts.showError('Could not retrieve data source data!');
            });
    }

}
